<template>
  <div v-if="getMqttIsInstanceConnected">
    <div v-if="isPageEnabled">
      <div v-if="getStatusPage" :style="configStyle">
        <div v-if="2 != getMode">
          <Popper
            class="labelStyle"
            style="position: relative; width: 100%"
            arrow
            offsetDistance="0"
          >
            <template #content>
              <div>
                There are 3 supported players:
                <ul>
                  <b>
                    <li>Basic</li>
                    <li>Advanced</li>
                    <li>DDP(Dynamic Display Protocol)</li>
                  </b>
                </ul>
                <hr />
                <b>Basic Player</b> supports short lighting sequences using only
                a single base board. This mode does not require any external
                processing module. All sequence handling is performed directly
                on the base board using its internal data storage.Remote control
                is not available in this mode because all communication
                interfaces reside on the external processing module, which is
                not present when operating with only the base board.<br />
                <b>Advanced Player</b> supports full‑length lighting sequences
                by using an external processing module. This mode offloads
                sequence decoding and playback to the accelerator board,
                enabling complex effects and higher frame rates of synchronized
                light shows. The base board handles output, while the
                accelerator module manages all sequence processing and
                timing.<br />
                <b>DDP Player</b> supports lighting sequences created with
                PC‑based sequencing software using the Dynamic Display
                Protocol.<br />
                <hr />
                Please select the desired player from the drop-down menu below.
              </div>
            </template>
            <div class="label" style="width: 100%">
              <i class="bx bx-info-circle" />
              <input
                type="text"
                class="textlabel"
                value="Player Configuration"
                readonly
              />
            </div>
          </Popper>
          <!-- MODE SELECTOR  BEGIN -->
          <div>
            <select
              class="selector"
              v-model="selectedCtrlMode"
              @change="onCtrlModeChange($event)"
            >
              <option
                v-for="index in getCtrlModes"
                :value="index.value"
                :key="index"
              >
                {{ index.text }}
              </option>
            </select>
          </div>
          <!-- MODE SELECTOR  END -->
          <!-- BASIC PLAYER  BEGIN -->
          <div v-if="255 == selectedCtrlMode">
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Activation in the context of Sequence Player refers to the
                  scenario that triggers an action to play a sequence.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Activation"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedActivation"
                @change="onActivationChange($event)"
              >
                <option value="1">Scenario #1</option>
                <option value="2">Scenario #2</option>
                <option value="3">Scenario #3</option>
                <option value="4">Scenario #4</option>
                <option value="5">Scenario #5</option>
                <option value="6">Scenario #6</option>
                <option value="7">Scenario #7</option>
                <option value="8">Scenario #8</option>
                <option value="9">Scenario #9 (OFF)</option>
              </select>
            </div>
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Sequence File contains a series of frames to display a light
                  show.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Sequence File"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedSequenceFile"
                @change="onSequenceFileChange($event)"
              >
                <option
                  v-for="index in getSequenceFiles"
                  :value="index.value"
                  :key="index"
                >
                  {{ index.text }}
                </option>
              </select>
            </div>
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Media File includes an audio track which serves as the
                  soundtrack for the light show.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Media File"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedMediaFile"
                @change="onMediaFileChange($event)"
              >
                <option
                  v-for="index in getMediaFiles"
                  :value="index.value"
                  :key="index"
                >
                  {{ index.text }}
                </option>
              </select>
            </div>
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Volume adjusts the sound level of a media file for a light
                  show.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input type="text" class="textlabel" value="Volume" readonly />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedVolume"
                @change="onVolumeChange($event)"
              >
                <option value="0">Silent</option>
                <option value="1">Quiet</option>
                <option value="2">Medium</option>
                <option value="3">Loud</option>
              </select>
            </div>
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Data storage is used to hold sequences and media files that
                  must reside on the base board when operating in Basic Player
                  mode. The progress indicator shows how much of the internal
                  storage is currently occupied by these files. The switch is
                  used to manage the update of the data storage. When ON the
                  data storage will be updated based on the current sequence and
                  media file selections. When OFF the data storage will not be
                  updated and the current content will remain unchanged. Please
                  note that updating the data storage can take noticeable time,
                  so it is best to keep the switch OFF unless an update is truly
                  needed.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Data Storage"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <CircleProgress :value="totalSize" :id="1" />
            </div>
            <div>
              <switches
                color="default"
                style="margin: 0vh 2vw 0vh 2vw"
                :value="baseModeDataStorageSwitchStatus"
                @click="toggleBaseModeDataStorage()"
              ></switches>
              <label class="label1">{{ baseModeDataStorageLabelText }}</label>
            </div>
          </div>
          <!-- BASIC PLAYER  END -->
          <!-- ADVANCED PLAYER  BEGIN -->
          <div v-if="253 == selectedCtrlMode">
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Activation in the context of Sequence Player refers to the
                  scenario that triggers an action to play a sequence.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Activation"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedActivation"
                @change="onActivationChange($event)"
              >
                <option value="1">Scenario #1</option>
                <option value="2">Scenario #2</option>
                <option value="3">Scenario #3</option>
                <option value="4">Scenario #4</option>
                <option value="5">Scenario #5</option>
                <option value="6">Scenario #6</option>
                <option value="7">Scenario #7</option>
                <option value="8">Scenario #8</option>
                <option value="9">Scenario #9 (OFF)</option>
              </select>
            </div>
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Sequence File contains a series of frames to display a light
                  show. Files listed in the pull‑down menu may include a (?)
                  prefix. This prefix indicates that the file has the correct
                  extension but its internal structure is not compatible with
                  Smart Light Controller. Such files cannot be used, and even if
                  a file with a (?) prefix is selected, it will not be played
                  until its format is corrected.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Sequence File"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedSequenceFile"
                @change="onSequenceFileChange($event)"
              >
                <option
                  v-for="index in getSequenceFiles"
                  :value="index.value"
                  :key="index"
                >
                  {{ index.text }}
                </option>
              </select>
            </div>
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Media File includes an audio track that plays as the
                  soundtrack for the light show. The system supports only WAV
                  files in the following format: 16-bit 16 kHz stereo. Files
                  listed in the pull‑down menu may include a (?) prefix. This
                  prefix indicates that the file has the correct extension but
                  its internal structure or audio format is not compatible. Such
                  files cannot be used, and even if a file with a (?) prefix is
                  selected, it will not be played until its format is corrected.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Media File"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedMediaFile"
                @change="onMediaFileChange($event)"
              >
                <option
                  v-for="index in getMediaFiles"
                  :value="index.value"
                  :key="index"
                >
                  {{ index.text }}
                </option>
              </select>
            </div>
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  Volume adjusts the sound level of a media file for a light
                  show.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Volume Help"
                  readonly
                />
              </div>
            </Popper>
            <div>
              <select
                class="selector"
                v-model="selectedVolume"
                @change="onVolumeChange($event)"
              >
                <option value="0">Silent</option>
                <option value="1">Quiet</option>
                <option value="2">Medium</option>
                <option value="3">Loud</option>
              </select>
            </div>
          </div>
          <!-- ADVANCED PLAYER  END -->
        </div>
        <!-- REGISTRATION  START -->
        <div v-if="2 == getMode">
          <Popper
            class="labelStyle"
            style="position: relative; width: 100%"
            arrow
            offsetDistance="0"
          >
            <template #content>
              <div>
                To start the registration, the registrar should submit token and
                credentials.
              </div>
            </template>
            <div class="label" style="width: 100%">
              <i class="bx bx-info-circle" />
              <input
                type="text"
                class="textlabel"
                :value="getRegistrationStatus"
                readonly
              />
            </div>
          </Popper>
          <form @submit.prevent="onSubmit">
            <div>
              <input
                class="input"
                style="width: 100%"
                id="token"
                v-model="form.token"
                placeholder="Token"
                type="text"
                autocomplete="on"
                required
              />
            </div>
            <div>
              <input
                class="input"
                style="width: 100%"
                id="name"
                v-model="form.name"
                placeholder="Name"
                type="text"
                autocomplete="on"
                required
              />
            </div>
            <div>
              <input
                class="input"
                style="width: 100%"
                id="passord"
                v-model="form.password"
                placeholder="Password"
                type="password"
                autocomplete="on"
                required
              />
            </div>
            <!-- </fieldset> -->
            <div>
              <input
                type="submit"
                class="input"
                style="width: 100%"
                value="Submit Registration"
                v-if="submitRegistration"
              />
            </div>
          </form>
        </div>
        <!-- REGISTRATION  END -->
        <button
          id="button"
          class="button"
          v-if="apply"
          @:click="handleApplyClick"
        >
          Apply
        </button>
      </div>
      <div v-else>
        <div v-if="2 == getConfigMode">
          <!-- BASIC MODE PROCESS BEGIN -->
          <div :style="configStyle">
            <Popper
              class="labelStyle"
              style="position: relative; width: 100%"
              arrow
              offsetDistance="0"
            >
              <template #content>
                <div>
                  During this transition, the system performs several operations
                  on the internal data storage, including erasing old content,
                  writing new sequences and media files, and verifying the
                  stored data. The progress indicator reflects each step until
                  the controller is fully ready to operate in Basic Player mode.
                </div>
              </template>
              <div class="label" style="width: 100%">
                <i class="bx bx-info-circle" />
                <input
                  type="text"
                  class="textlabel"
                  value="Basic Player Transition"
                  readonly
                />
              </div>
            </Popper>
            <CircleProgress :value="getProgress" :id="2" />
            <button id="button" class="button" @:click="handleCancelClick">
              Cancel
            </button>
          </div>
          <!-- BASIC MODE PROCESS END -->
        </div>
        <div v-else :style="pageStyle">Player Transition...</div>
      </div>
    </div>
    <div v-else :style="pageStyle">Disabled</div>
  </div>
  <div v-else :style="pageStyle">
    {{ connectionMsg }}
  </div>
</template>
<script>
// @ is an alias to /src
import AppConstants from "@/AppConstants.js";
import Switches from "/node_modules/vue-switches";
import CircleProgress from "@/components/CircleProgress.vue";
import { mapGetters, mapMutations } from "vuex";
import Popper from "vue3-popper";
const ACTIVATION_MIN_NUMBER = 1;
const ACTIVATION_MAX_NUMBER = 9;
const OFF_DATA_STORTAGE_MESSAGE = "OFF - Keep current content";
const ON_DATA_STORTAGE_MESSAGE = "ON - Update storage";
export default {
  name: "Config",
  data: function () {
    let size = AppConstants.get2Size();
    return {
      selectedCtrlMode: 0,
      selectedActivation: 1,
      selectedSequenceFile: 0,
      selectedMediaFile: 0,
      selectedVolume: 0,
      totalSize: 0,
      apply: false,
      submitRegistration: true,
      sequenceFileApply: true,
      mediaFileApply: true,
      isPageEnabled: true,
      baseModeDataStorageSwitchStatus: false,
      baseModeDataStorageLabelText: OFF_DATA_STORTAGE_MESSAGE,
      configStyle: {
        position: "absolute",
        background: "black",
        border: "1px solid black",
        left: AppConstants.MENU_WIDTH + "px",
        top: "0vh",
        width: size.width + "vw",
        height: "100vh",
        color: "white",
      },
      pageStyle: {
        position: "absolute",
        background: "black",
        border: "3px solid gray",
        left: AppConstants.MENU_WIDTH + "px",
        width: size.width + "vw",
        color: "white",
        fontSize: "x-large",
        margin: "auto",
        textAlign: "center",
        padding: "10px",
      },
      form: {
        password: "",
        name: "",
      },
    };
  },
  components: {
    Popper,
    CircleProgress,
    Switches,
  },
  computed: {
    ...mapGetters({
      mqttInstance: "mqttStore/getMqttInstance",
      getMqttUserTopic: "mqttStore/getMqttUserTopic",
      getMqttIsInstanceConnected: "mqttStore/getMqttIsInstanceConnected",
      getMode: "configStore/getMode",
      getCtrlMode: "configStore/getCtrlMode",
      getCtrlModes: "configStore/getCtrlModes",
      getConfigMode: "configStore/getConfigMode",
      getUpdateCounter: "configStore/getUpdateCounter",
      getSequenceFiles: "configStore/getSequenceFiles",
      getMediaFiles: "configStore/getMediaFiles",
      getSequenceByIndex: "configStore/getSequenceByIndex",
      getSequenceFileByIndex: "configStore/getSequenceFileByIndex",
      getMediaByIndex: "configStore/getMediaByIndex",
      getMediaFileByIndex: "configStore/getMediaFileByIndex",
      getVolumeByIndex: "configStore/getVolumeByIndex",
      getStatusPage: "configStore/getStatusPage",
      getRegistrationStatus: "configStore/getRegistrationStatus",
      getProgress: "configStore/getProgress",
    }),
    connectionMsg() {
      return "Waiting for MQTT connection...";
    },
  },
  methods: {
    ...mapMutations({
      setSequence: "configStore/setSequence",
      setMedia: "configStore/setMedia",
      setVolume: "configStore/setVolume",
      setStatusPage: "configStore/setStatusPage",
      setRegistrationStatus: "configStore/setRegistrationStatus",
      setConfigMode: "configStore/setConfigMode",
    }),
    processIndicator: function () {
      let ndx, index;
      let length = 1 + AppConstants.NUMBER_OF_STRIPS;
      let totalMediaSize = 0,
        totalSequenceSize = 0,
        totalSize;
      let processedIndexesArray = [];
      let processedIndexesLength = 0;
      let processedIndex = 0;
      let processedFlag = false;
      /* Calculate all media files */
      if (AppConstants.CONFIG_MQTT_DEBUG_MODE) {
        // eslint-disable-next-line
        console.log("Media Files");
      }
      for (ndx = 1; ndx <= length; ndx++) {
        index = this.getMediaByIndex(ndx);
        /* Check if the file is already processed */
        processedFlag = false;
        for (
          processedIndex = 0;
          processedIndexesLength > processedIndex;
          processedIndex++
        ) {
          if (processedIndexesArray[processedIndex] == index) {
            processedFlag = true;
            break;
          }
        }
        if (processedFlag) continue;
        /* -- */
        processedIndexesArray[processedIndexesLength++] = index;
        /* -- */
        totalMediaSize += this.getMediaFiles[index].size;
        if (AppConstants.CONFIG_MQTT_DEBUG_MODE) {
          // eslint-disable-next-line
            console.log(this.getMediaFiles[index].text+" file size ="+this.getMediaFiles[index].size);
        }
      }
      /* Calculate all sequence files */
      if (AppConstants.CONFIG_MQTT_DEBUG_MODE) {
        // eslint-disable-next-line
        console.log("Sequence Files");
      }
      processedIndexesLength = 0;
      for (ndx = 1; ndx <= length; ndx++) {
        index = this.getSequenceByIndex(ndx);
        /* Check if the file is already processed */
        processedFlag = false;
        for (
          processedIndex = 0;
          processedIndexesLength > processedIndex;
          processedIndex++
        ) {
          if (processedIndexesArray[processedIndex] == index) {
            processedFlag = true;
            break;
          }
        }
        if (processedFlag) continue;
        /* -- */
        processedIndexesArray[processedIndexesLength++] = index;
        /* -- */
        if (AppConstants.CONFIG_MQTT_DEBUG_MODE) {
          // eslint-disable-next-line
            console.log(this.getSequenceFiles[index].text+" file size ="+this.getSequenceFiles[index].size);
        }
        totalSequenceSize += this.getSequenceFiles[index].size;
      }
      /* Calculate percentage */
      totalSize = totalMediaSize + totalSequenceSize;
      totalSize = (totalSize * 100) / AppConstants.BASE_BOARD_DATASTORAGE_SIZE;
      totalSize = Math.ceil(Number(totalSize));
      this.totalSize = totalSize;
      if (AppConstants.CONFIG_MQTT_DEBUG_MODE) {
        // eslint-disable-next-line
        console.log("media "+totalMediaSize+" sequence " + totalSequenceSize);
        // eslint-disable-next-line
        console.log("total "+totalSize);
      }
    },
    onCtrlModeChange: function (event) {
      this.selectedCtrlMode = event.target.value;
      this.setApply();
      this.processIndicator();
    },
    onActivationChange: function (event) {
      this.selectedActivation = event.target.value;
      this.selectedSequenceFile = this.getSequenceByIndex(
        this.selectedActivation
      );
      this.selectedMediaFile = this.getMediaByIndex(this.selectedActivation);
      this.selectedVolume = this.getVolumeByIndex(this.selectedActivation);
      this.setApply();
      this.processIndicator();
    },
    setApply: function () {
      if (this.sequenceFileApply && this.mediaFileApply) {
        this.apply = true;
      } else {
        this.apply = false;
      }
    },
    onSequenceFileChange: function (event) {
      let val = { index: Number, value: Number };
      let selectedFileName = "";
      this.sequenceFileApply = true;
      this.selectedSequenceFile = event.target.value;
      val.index = this.selectedActivation;
      val.value = this.selectedSequenceFile;
      this.setSequence(val);
      /* -- */
      for (
        let ndx = ACTIVATION_MIN_NUMBER;
        ACTIVATION_MAX_NUMBER >= ndx;
        ndx++
      ) {
        selectedFileName = this.getSequenceFileByIndex(ndx);
        if (selectedFileName.includes("?")) {
          this.sequenceFileApply = false;
          break;
        }
      }
      /* -- */
      this.setApply();
      this.processIndicator();
    },
    onMediaFileChange: function (event) {
      let val = { index: Number, value: Number };
      let selectedFileName = "";
      this.mediaFileApply = true;
      this.selectedMediaFile = event.target.value;
      val.index = this.selectedActivation;
      val.value = this.selectedMediaFile;
      this.setMedia(val);
      /* -- */
      for (
        let ndx = ACTIVATION_MIN_NUMBER;
        ACTIVATION_MAX_NUMBER >= ndx;
        ndx++
      ) {
        selectedFileName = this.getMediaFileByIndex(ndx);
        if (selectedFileName.includes("?")) {
          this.mediaFileApply = false;
          break;
        }
      }
      /* -- */
      this.setApply();
      this.processIndicator();
    },
    onVolumeChange: function (event) {
      let val = { index: Number, value: Number };
      this.selectedVolume = event.target.value;
      val.index = this.selectedActivation;
      val.value = this.selectedVolume;
      this.setVolume(val);
      this.setApply();
      this.processIndicator();
    },
    handleApplyClick: function () {
      let ndx;
      let message = "{";
      message += "'name':'config'";
      message += ",'mode':'set'";
      message += ",'ctrlmode':" + this.selectedCtrlMode;
      /* -- */
      message += ",'datastorage':";
      if (this.baseModeDataStorageSwitchStatus) {
        message += "1";
      } else {
        message += "0";
      }
      /* -- */
      if (255 == this.selectedCtrlMode) {
        this.setConfigMode("2");
      }
      if (253 == this.selectedCtrlMode) {
        this.setConfigMode("3");
      }
      /* Selected Sequence Array */
      message += ",'selectedSequenceFileArray': [";
      for (ndx = ACTIVATION_MIN_NUMBER; ACTIVATION_MAX_NUMBER >= ndx; ndx++) {
        message += "'";
        message += this.getSequenceFileByIndex(ndx);
        message += "'";
        if (ACTIVATION_MAX_NUMBER > ndx) message += ",";
      }
      message += "]";
      /* Selected Media Array */
      message += ",'selectedMediaFileArray': [";
      for (ndx = ACTIVATION_MIN_NUMBER; ACTIVATION_MAX_NUMBER >= ndx; ndx++) {
        message += "'";
        message += this.getMediaFileByIndex(ndx);
        message += "'";
        if (ACTIVATION_MAX_NUMBER > ndx) message += ",";
      }
      message += "]";
      /* Volume Array */
      message += ",'volumeArray': [";
      for (ndx = ACTIVATION_MIN_NUMBER; ACTIVATION_MAX_NUMBER >= ndx; ndx++) {
        message += this.getVolumeByIndex(ndx).toString();
        if (ACTIVATION_MAX_NUMBER > ndx) message += ",";
      }
      message += "]";
      /* -- */
      message += "}";
      if (this.getMqttIsInstanceConnected) {
        this.mqttInstance.publish(
          this.getMqttUserTopic + "/update",
          message,
          0,
          {},
          () => {}
        );
        this.setStatusPage(0);
      }
      this.apply = false;
    },
    handleCancelClick: function () {
      let message = "{'name':'cancel'}";
      if (this.getMqttIsInstanceConnected) {
        this.mqttInstance.publish(
          this.getMqttUserTopic + "/update",
          message,
          0,
          {},
          () => {}
        );
      }
    },
    toggleBaseModeDataStorage() {
      /* -- */
      if (this.baseModeDataStorageSwitchStatus) {
        this.baseModeDataStorageSwitchStatus = false;
        this.baseModeDataStorageLabelText = OFF_DATA_STORTAGE_MESSAGE;
      } else {
        this.baseModeDataStorageSwitchStatus = true;
        this.baseModeDataStorageLabelText = ON_DATA_STORTAGE_MESSAGE;
      }
    },
    onSubmit() {
      let message = "{";
      message += "'token':'" + this.form.token + "'";
      message += ",'name':'" + this.form.name + "'";
      message += ",'password':'" + this.form.password + "'";
      message += "}";
      /* -- */
      if (this.submitRegistration) {
        this.submitRegistration = false;
        if (this.getMqttIsInstanceConnected) {
          this.mqttInstance.publish(
            this.getMqttUserTopic + "/registrar/request",
            message,
            0,
            {},
            () => {}
          );
        } else {
          this.setRegistrationStatus("No connection");
        }
      }
    },
  },
  created() {
    if (AppConstants.CONFIG_INSTALLATION_MODE == this.getMode) {
      this.isPageEnabled = false;
    }
    this.setRegistrationStatus("Registration");
    let message = "{";
    message += "'name':'config'";
    message += ",'mode':'get'";
    message += "}";
    if (this.getMqttIsInstanceConnected) {
      this.mqttInstance.publish(
        this.getMqttUserTopic + "/update",
        message,
        0,
        {},
        () => {}
      );
    }
  },
  mounted() {},
  watch: {
    getUpdateCounter: function () {
      this.selectedCtrlMode = this.getCtrlMode;
      this.selectedActivation = 1;
      this.selectedSequenceFile = this.getSequenceByIndex(
        this.selectedActivation
      );
      this.selectedMediaFile = this.getMediaByIndex(this.selectedActivation);
      this.selectedVolume = this.getVolumeByIndex(this.selectedActivation);
      if (0 == this.getConfigMode || 1 == this.getConfigMode) {
        this.setStatusPage(1);
      } else if (2 == this.getConfigMode && 255 == this.selectedCtrlMode) {
        this.setStatusPage(0);
      }
      this.processIndicator();
    },
  },
};
</script>
<style scoped>
.input {
  color: white;
  background-color: black;
  font-size: large;
  margin: 1vh 0vw 1vh 0vw;
  border: 3px solid #303030;
  padding: 1px;
  border-radius: 25px;
  text-align: center;
}
.input:hover {
  border: 3px solid white;
}
.input:focus {
  border: 3px solid white;
  outline: none;
}
.label {
  position: relative;
  color: gray;
  background-color: black;
  caret-color: transparent;
  font-size: large;
  margin: 1vh 0vw 1vh 0vw;
  border: 3px solid #303030;
  padding: 1px;
  border-radius: 25px;
  text-align: center;
}
.label:hover {
  border: 3px solid white;
}
.label:focus {
  border: 3px solid white;
  outline: none;
}
.button {
  color: white;
  border: 3px solid #303030;
  background-color: black;
  text-align: center;
  text-decoration: none;
  font-size: large;
  transition-duration: 0.4s;
  cursor: pointer;
  position: center;
  width: 100%;
  margin: 1vh 0vw 1vh 0vw;
  padding: 10px;
  border-radius: 25px;
}
.button:hover {
  border: 3px solid white;
}
.selector {
  color: white;
  border: 3px solid #303030;
  background-color: black;
  text-align: center;
  font-size: large;
  transition-duration: 0.4s;
  cursor: pointer;
  position: center;
  margin: 1vh 0vw 1vh 0vw;
  padding: 1px;
  border-radius: 25px;
  width: 100%;
}
.selector:focus {
  border: 3px solid #303030;
  outline: none;
}
.selector:hover {
  border: 3px solid white;
}
.labelStyle {
  position: relative;
  text-align: left;
  float: left;
  --popper-theme-background-color: white;
  --popper-theme-background-color-hover: white;
  --popper-theme-text-color: black;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 25px;
  --popper-theme-padding: 10px;
}
.separator {
  height: 1px;
  background-color: white;
  margin: 10px 0;
}
.textlabel {
  color: gray;
  background-color: black;
  font-size: large;
  margin: 0vh 1vw 0vh 1vw;
  border: none;
  outline: none;
  text-align: center;
}
:deep(.wrapper) {
  height: 200px;
}
.label1 {
  font-size: normal;
  color: lightgrey;
}
</style>
